<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="资源档案"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
      :default-sort="{ prop: 'ReleaseTime', order: 'descending' }"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="资源标题">
          <el-input
            v-model="params.InfoTitle"
            placeholder="请输入资源标题"
            clearable
          />
        </el-form-item>

        <el-form-item label="资源类别">
          <el-select
            v-model="params.InfoTypeId"
            placeholder="请选择资源类别"
            clearable
          >
            <el-option
              v-for="item in list"
              :key="item.RecordId"
              :value="item.RecordId"
              :label="item.TypeName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布人">
          <el-input
            v-model="params.PersonName"
            placeholder="请输入发布人"
            clearable
          />
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
            v-model.trim="params.ReleaseTimeBegin"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            v-model.trim="params.ReleaseTimeEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="是否置顶">
          <el-select v-model="params.IfTop" placeholder="请选择" clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            size="mini"
            v-model="params.State"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="待审" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="InfoTitle" label="资源标题" />
        <el-table-column prop="TypeName" label="资源类别" />
        <!-- <el-table-column prop="InfoContentText" label="内容" show-overflow-tooltip /> -->
        <el-table-column prop="PersonName" label="发布人" />
        <el-table-column
          prop="ReleaseTime"
          align="center"
          label="发布时间"
          width="200"
          sortable
        >
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDatetimeString(row.ReleaseTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="IfTop"
          align="center"
          label="是否置顶"
          width="80"
        >
          <template slot-scope="{ row }">
            <el-tag size="small" type="danger" v-if="row.IfTop == 0">否</el-tag>
            <el-tag size="small" type="success" v-else>是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ClickCount" label="点击数" />
        <el-table-column prop="State" align="center" label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.State == 0">草稿</el-tag>
            <el-tag size="small" type="primary" v-else-if="row.State == 1"
              >待审</el-tag
            >
            <el-tag size="small" type="success" v-else-if="row.State == 2"
              >审核通过</el-tag
            >
            <el-tag size="small" type="danger" v-else-if="row.State == 3"
              >不通过</el-tag
            >
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/resources/detail").default,
      api2: require("@/api/resources/type").default,
      params: {
        InfoTitle: "",
        InfoTypeId: null,
        PersonName: "",
        ReleaseTimeBegin: "",
        ReleaseTimeEnd: "",
        InfoContent: "",
        IfTop: null,
        State: null,
      },
      list: [],
    };
  },
  mounted() {
    this.api2.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.list = res.Data;
      }
    });
  },
  beforeMount() {
    if (this.$route.query.state) {
      this.params.State = Number(this.$route.query.state);
    }
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 0, Data: [] });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>